export const resetTokens = () => {
  document.cookie = `accessToken=; expires=${-1}; path=/`;
  document.cookie = `refreshToken=; expires=${-1}; path=/`;
};
